.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding-right: 10px;
    border-bottom: 1px solid color-mix(in srgb, var(--dib-ink) 20%, transparent);
    transition: background-color 0.1s ease;

    &:hover {
        background-color: color-mix(in srgb, white 30%, transparent);
    }
}

.link {
    display: block;
    flex: 1;
    min-width: 0;
    padding-block: var(--mantine-spacing-sm);
    padding-left: var(--mantine-spacing-sm);
    text-decoration: none;
    color: var(--dib-ink);
}

.name {
    font-size: var(--mantine-font-size-sm);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.description {
    font-size: var(--mantine-font-size-xs);
    color: color-mix(in srgb, var(--dib-ink) 75%, transparent);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rightSection {
    flex-shrink: 0;
}
